import { User, UserPartial } from "model/user";
import { normalizeTaxId } from "shared/texting-fields";
import { BusinessTaxIdForm } from "./business-tax-id";
import { SetupForm } from "./setup-dialog/steps";

export interface ConfigurationForm extends BusinessTaxIdForm {
	mobile: string;
	callForwarding: string;
	timeZone: string;
}

const taxIdFields = (form: BusinessTaxIdForm, sendTaxId: boolean): UserPartial => ({
	textMessageHasTaxId: form.hasTaxId,
	...(form.hasTaxId && {
		textMessageTaxIdType: form.taxIdType,
		textMessageBusinessType: form.businessType || null,
		textMessageLegalBusinessName: form.legalBusinessName.trim(),
		...(sendTaxId && { textMessageTaxId: normalizeTaxId(form.taxId) }),
	}),
});

/** What the setup wizard's Finish saves. */
export const setupPayload = (user: User, form: SetupForm): UserPartial => ({
	...user,
	textMessageCallForwarding: form.callForwarding,
	tcpaCompliantTimeZone: form.timeZone,
	textMessageOptIn: true,
	emailSignupPhoneRequired: form.phoneRequired,
	textMessageVerificationMobile: form.mobile,
	...taxIdFields({ ...form, taxIdEdited: true }, true),
});

/**
 * What the Texting page's Save Changes sends. The Tax ID goes only when the client typed a new one, and the paused
 * date is always sent back, because the server writes it on every save.
 */
export const configurationPayload = (user: User, form: ConfigurationForm): UserPartial => ({
	...user,
	textMessageVerificationMobile: form.mobile,
	textMessageCallForwarding: form.callForwarding,
	tcpaCompliantTimeZone: form.timeZone,
	dripMMSOptOutDate: user.dripMMSOptOutDate ?? null,
	...taxIdFields(form, form.taxIdEdited),
});
